import { activateStudentReport } from 'apis/Payment/Subscription';
import { useAppStore } from 'hooks/useAppStore';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { ErrorResponse } from 'types';
import { fetchServerError } from 'utils';

export const useActivateStudentReport = () => {
  const queryClient = useQueryClient();
  const {
    subscriptionStore: { currentSubscription, updateCurrentSubscription },
    workspaceStore: { currentWorkspaceId },
  } = useAppStore();

  return useMutation(activateStudentReport, {
    onSuccess: data => {
      updateCurrentSubscription({ ...currentSubscription, studentReportItem: data.studentReportItem });
      toast.success('Learner Report has been activated');
      queryClient.invalidateQueries(['workspaces', currentWorkspaceId, 'usage-record']);
    },
    onError: (error: ErrorResponse) => {
      toast(fetchServerError(error), { type: 'error' });
    },
  });
};
